import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

function formatErr(detail) {
  if (!detail) return "Anmeldung fehlgeschlagen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center bg-slate-50 relative"
      data-testid="login-page"
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/3062948/pexels-photo-3062948.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-white/85 via-white/75 to-slate-50/90" />

      <form
        onSubmit={onSubmit}
        className="relative z-10 w-[420px] max-w-[90vw] bg-white border border-slate-200 rounded-md p-8"
        data-testid="login-form"
      >
        <div className="mb-7">
          <div className="text-[11px] tracking-[0.2em] uppercase text-slate-500 mb-2">
            Wandplaner
          </div>
          <h1 className="text-3xl tracking-tight font-semibold text-slate-900 leading-tight"
              style={{ fontFamily: "Manrope, ui-sans-serif" }}>
            Anmelden
          </h1>
          <p className="text-sm text-slate-500 mt-2">
            Persönlicher Zugang zum Kapazitätsplaner.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-wider text-slate-500">
              E-Mail
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="h-10 mt-1.5"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-wider text-slate-500">
              Passwort
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="h-10 mt-1.5"
              data-testid="login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            className="w-full h-10 bg-slate-900 hover:bg-slate-800 text-white"
            data-testid="login-submit-button"
          >
            {submitting ? "Wird angemeldet…" : "Anmelden"}
          </Button>
        </div>
      </form>
    </div>
  );
}
